<template>
  <v-btn class="qa-default-btn"
    @click.stop="$emit('click', $event)"
    :class="customClasses"
    rounded
    fab
    small
    depressed>
    <v-icon size="16" :color="iconColor">icon-plus-s</v-icon>
  </v-btn>
</template>
<script>

export default {
  name: 'QADefaultBtn',
  props: {
    isActive: {
      type: Boolean,
      required: true
    },
    btnClass: {
      type: String,
      required: false
    },
    iconColor: {
      type: String,
      default: '#8c9197'
    }
  },
  computed: {
    customClasses() {
      const classes = []
      if (this.isActive) classes.push('is-active')
      if (this.btnClass) classes.push(this.btnClass)
      return classes
    }
  }
}
</script>
<style lang="scss" scoped>
@import "@/assets/scss/abstract/_variables.scss";

.qa-default-btn {

  &.is-active .v-icon {
    transform: rotate(-135deg);
  }
}
</style>
